import { makeStyles, TableCellLayout } from "@fluentui/react-components";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { SkanskaColorTokens } from "../../style/colors";

const useStyles = makeStyles({
  link: {
    textDecoration: "none",
    color: SkanskaColorTokens.color_action_blue,
    overflowWrap: "break-word",
    display: "block",
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});

interface LinkedDataGridCellProps {
  children: ReactNode;
  route: string;
  external?: boolean;
}

const LinkedDataGridCell = (props: LinkedDataGridCellProps) => {
  const { children, route, external } = props;
  const classes = useStyles();

  return (
    <TableCellLayout>
      {external ? (
        <a
          href={route}
          className={classes.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      ) : (
        <Link
          to={route}
          className={classes.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </Link>
      )}
    </TableCellLayout>
  );
};

export default LinkedDataGridCell;
